export enum PlayShortHandedAttribute {
  Permanent = 3043,
  Temporary = 3044,
}
